var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m451.82 41.176c-64.889-27.322-130.773-41.176-195.82-41.176s-130.931 13.854-195.82 41.176c-5.563 2.342-9.18 7.789-9.18 13.824v169.516c0 62.777 18.979 123.178 54.886 174.672 35.906 51.495 86.022 90.185 144.929 111.888 3.348 1.233 7.023 1.233 10.371 0 58.906-21.702 109.021-60.393 144.929-111.887 35.905-51.496 54.885-111.896 54.885-174.673v-169.516c0-6.035-3.617-11.482-9.18-13.824zm-20.82 183.34c0 113.006-70.093 215.353-175 256.438-104.907-41.087-175-143.433-175-256.438v-159.458c116.176-46.436 233.824-46.436 350 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.317 82.283c-6.156 2.023-10.317 7.771-10.317 14.25v127.987c0 46.11 13.084 91.258 37.839 130.563 24.601 39.062 59.392 70.281 100.612 90.285 4.135 2.006 8.962 2.006 13.098 0 41.221-20.004 76.012-51.224 100.612-90.285 24.755-39.306 37.839-84.453 37.839-130.563v-127.987c0-6.479-4.161-12.228-10.317-14.25-44.994-14.786-90.308-22.283-134.683-22.283s-89.69 7.497-134.683 22.283zm249.683 142.237c0 79.482-44.905 153.473-115 190.539-70.095-37.066-115-111.057-115-190.539v-116.989c38.551-11.637 77.185-17.531 115-17.531s76.449 5.894 115 17.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.502 249.393c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l35.355 35.355c5.858 5.858 15.355 5.858 21.213 0l84.854-84.854c5.858-5.857 5.858-15.355 0-21.213-5.857-5.857-15.355-5.857-21.213 0l-74.247 74.247z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.7d3510dea4a16d6128c18b77fe758d3c.svg";
export { ForwardRef as ReactComponent };